var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defaultstats } from './stats';
export function shuffle(array) {
    var _a;
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        _a = [array[j], array[i]], array[i] = _a[0], array[j] = _a[1];
    }
    return array;
}
export function coinToss(probability) {
    return Math.random() < probability;
}
export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
}
export function test(page, group) {
    return __awaiter(this, void 0, void 0, function () {
        var q, i, url, resp;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    q = [];
                    for (i = page; i > -1; i += -1) {
                        url = "https://qwerzxvxzvzxvxzv.herokuapp.com/words?page=".concat(i, "&group=").concat(group);
                        q.push(fetch(url));
                    }
                    return [4 /*yield*/, Promise.all(q.map(function (elem) { return __awaiter(_this, void 0, void 0, function () {
                            var resp1, body;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, elem];
                                    case 1:
                                        resp1 = _a.sent();
                                        return [4 /*yield*/, resp1.json()];
                                    case 2:
                                        body = _a.sent();
                                        return [2 /*return*/, body];
                                }
                            });
                        }); }))];
                case 1:
                    resp = _a.sent();
                    return [2 /*return*/, resp];
            }
        });
    });
}
export function prepare(page, group, fromPage) {
    if (page === void 0) { page = 29; }
    if (group === void 0) { group = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var arr1, trick, a, isUser, known_1, familiar_1, filtered, familiar_2, filtered;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    arr1 = [];
                    trick = [];
                    return [4 /*yield*/, test(page, group)];
                case 1:
                    a = (_a.sent());
                    return [4 /*yield*/, isUserHere()];
                case 2:
                    isUser = _a.sent();
                    if (!(isUser && fromPage)) return [3 /*break*/, 5];
                    return [4 /*yield*/, getKnownWords(page, group)];
                case 3:
                    known_1 = _a.sent();
                    return [4 /*yield*/, getUserWords()];
                case 4:
                    familiar_1 = _a.sent();
                    a.forEach(function (element) { return shuffle(element); });
                    filtered = a
                        .flat()
                        .filter(function (elem) { return !known_1.some(function (element) { return element._id === elem.id; }); });
                    filtered.forEach(function (element) {
                        var elem = familiar_1.find(function (q) { return q.wordId === element.id; });
                        if (elem) {
                            element.properties = elem;
                        }
                        else {
                            element.isNew = true;
                        }
                    });
                    arr1 = filtered;
                    return [3 /*break*/, 8];
                case 5:
                    if (!isUser) return [3 /*break*/, 7];
                    return [4 /*yield*/, getUserWords()];
                case 6:
                    familiar_2 = _a.sent();
                    filtered = a.flat();
                    filtered.forEach(function (element) {
                        var elem = familiar_2.find(function (q) { return q.wordId === element.id; });
                        if (elem) {
                            element.properties = elem;
                        }
                        else {
                            element.isNew = true;
                        }
                    });
                    arr1 = shuffle(filtered);
                    return [3 /*break*/, 8];
                case 7:
                    if (fromPage) {
                        a.forEach(function (element) { return shuffle(element); });
                        arr1 = a.flat();
                    }
                    else {
                        arr1 = shuffle(a.flat());
                    }
                    _a.label = 8;
                case 8:
                    arr1.map(function (elem) { return __awaiter(_this, void 0, void 0, function () {
                        var isTrue;
                        return __generator(this, function (_a) {
                            isTrue = coinToss(0.5);
                            trick.push({
                                correct: isTrue,
                                word: elem.word,
                                translate: createTranslation(a.flat(), elem, isTrue),
                                audio: elem.audio,
                                phrase: elem.audioExample,
                                correctTranslate: elem.wordTranslate,
                                properties: elem.properties,
                                isNew: elem.isNew,
                                id: elem.id,
                            });
                            return [2 /*return*/];
                        });
                    }); });
                    return [2 /*return*/, trick];
            }
        });
    });
}
export function fetchWords(page, group) {
    if (page === void 0) { page = 0; }
    if (group === void 0) { group = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var res, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("https://qwerzxvxzvzxvxzv.herokuapp.com/words?page=".concat(page, "&group=").concat(group))];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    resp = _a.sent();
                    return [2 /*return*/, resp];
            }
        });
    });
}
function createTranslation(arr, element, isTrue) {
    if (isTrue)
        return element.wordTranslate;
    else {
        var translate = '';
        var found = false;
        while (!found) {
            translate = arr[getRandomInt(0, arr.length)].wordTranslate;
            if (element.wordTranslate !== translate)
                found = true;
        }
        return translate;
    }
}
export function playaudio(futureAudio) {
    return __awaiter(this, void 0, void 0, function () {
        var audio, context, buffer1, source;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, futureAudio];
                case 1:
                    audio = _a.sent();
                    context = new AudioContext();
                    return [4 /*yield*/, context.decodeAudioData(audio)];
                case 2:
                    buffer1 = _a.sent();
                    source = context.createBufferSource();
                    source.buffer = buffer1;
                    source.connect(context.destination);
                    source.start(0);
                    return [2 /*return*/];
            }
        });
    });
}
export function getaudio(path) {
    return __awaiter(this, void 0, void 0, function () {
        var url, resp, body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = 'https://qwerzxvxzvzxvxzv.herokuapp.com/' + path;
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    resp = _a.sent();
                    body = resp.arrayBuffer();
                    return [2 /*return*/, body];
            }
        });
    });
}
export function getUserWord(id) {
    return __awaiter(this, void 0, void 0, function () {
        var NonStringedUser, user, token, url, rawResp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    NonStringedUser = localStorage.getItem('userInfo');
                    user = JSON.parse(NonStringedUser);
                    token = user.token;
                    url = "https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(user.userId, "/words/").concat(id);
                    return [4 /*yield*/, fetch(url, {
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                            },
                        })];
                case 1:
                    rawResp = _a.sent();
                    if (!rawResp.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, rawResp.json()];
                case 2:
                    resp = _a.sent();
                    return [2 /*return*/, resp];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function getUserWords() {
    return __awaiter(this, void 0, void 0, function () {
        var NonStringedUser, user, token, url, rawResp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    NonStringedUser = localStorage.getItem('userInfo');
                    user = JSON.parse(NonStringedUser);
                    token = user.token;
                    url = "https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(user.userId, "/words");
                    return [4 /*yield*/, fetch(url, {
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                            },
                        })];
                case 1:
                    rawResp = _a.sent();
                    return [4 /*yield*/, rawResp.json()];
                case 2:
                    resp = _a.sent();
                    return [2 /*return*/, resp];
            }
        });
    });
}
export function getstats() {
    return __awaiter(this, void 0, void 0, function () {
        var isUser, NonStringedUser, user, token, url, rawResp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, isUserHere()];
                case 1:
                    isUser = _a.sent();
                    if (!isUser) return [3 /*break*/, 4];
                    NonStringedUser = localStorage.getItem('userInfo');
                    user = JSON.parse(NonStringedUser);
                    token = user.token;
                    url = "https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(user.userId, "/statistics");
                    return [4 /*yield*/, fetch(url, {
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                            },
                        })];
                case 2:
                    rawResp = _a.sent();
                    if (!rawResp.ok)
                        return [2 /*return*/, false];
                    return [4 /*yield*/, rawResp.json()];
                case 3:
                    resp = _a.sent();
                    return [2 /*return*/, resp];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function setUserWords(wordId, word, method) {
    if (method === void 0) { method = 'POST'; }
    return __awaiter(this, void 0, void 0, function () {
        var NonStringedUser, user, token, url, rawResp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    NonStringedUser = localStorage.getItem('userInfo');
                    user = JSON.parse(NonStringedUser);
                    token = user.token;
                    url = "https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(user.userId, "/words/").concat(wordId);
                    return [4 /*yield*/, fetch(url, {
                            method: method,
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(word),
                        })];
                case 1:
                    rawResp = _a.sent();
                    return [4 /*yield*/, rawResp.json()];
                case 2:
                    resp = _a.sent();
                    return [2 /*return*/, resp];
            }
        });
    });
}
export function getKnownWords(page, group) {
    if (page === void 0) { page = 29; }
    if (group === void 0) { group = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var NonStringedUser, user, token, id, filter, baseurl, rawResp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    NonStringedUser = localStorage.getItem('userInfo');
                    user = JSON.parse(NonStringedUser);
                    token = user.token;
                    id = user.userId;
                    filter = { 'userWord.optional.isKnown': true };
                    baseurl = "https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(id, "/aggregatedWords?group=").concat(group, "&wordsPerPage=\n").concat((page + 1) * 20, "&filter=").concat(JSON.stringify(filter));
                    return [4 /*yield*/, fetch(baseurl, {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                            },
                        })];
                case 1:
                    rawResp = _a.sent();
                    return [4 /*yield*/, rawResp.json()];
                case 2:
                    resp = _a.sent();
                    return [2 /*return*/, resp[0].paginatedResults];
            }
        });
    });
}
export function prepareAudioChallenge(page, group, fromPage) {
    if (page === void 0) { page = 29; }
    if (group === void 0) { group = 0; }
    if (fromPage === void 0) { fromPage = false; }
    return __awaiter(this, void 0, void 0, function () {
        var arr, isUser, preResult, known_2, familiar_3, filtered, falseWords_1, _a, familiar_4, falseWords_2, _b, falseWords_3, _c, falseWords_4, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, test(page, group)];
                case 1:
                    arr = _e.sent();
                    return [4 /*yield*/, isUserHere()];
                case 2:
                    isUser = _e.sent();
                    if (!(isUser && fromPage)) return [3 /*break*/, 6];
                    arr.forEach(function (element) { return shuffle(element); });
                    return [4 /*yield*/, getKnownWords(page, group)];
                case 3:
                    known_2 = _e.sent();
                    return [4 /*yield*/, getUserWords()];
                case 4:
                    familiar_3 = _e.sent();
                    filtered = arr
                        .flat()
                        .filter(function (elem) { return !known_2.some(function (element) { return element._id === elem.id; }); });
                    filtered.forEach(function (element) {
                        var elem = familiar_3.find(function (q) { return q.wordId === element.id; });
                        if (elem) {
                            element.properties = elem;
                            element.isNew = false;
                        }
                        else {
                            element.isNew = true;
                        }
                    });
                    preResult = filtered.slice(0, 20);
                    _a = shuffle;
                    return [4 /*yield*/, createFalseWords(preResult)];
                case 5:
                    falseWords_1 = _a.apply(void 0, [_e.sent()]);
                    preResult.forEach(function (element, index) {
                        element.variant = [element.wordTranslate];
                        for (var i = 0; i < 4; i += 1) {
                            element.variant.push(falseWords_1[index * 4 + i].wordTranslate);
                        }
                        element.variant = shuffle(element.variant);
                    });
                    return [3 /*break*/, 13];
                case 6:
                    if (!isUser) return [3 /*break*/, 9];
                    return [4 /*yield*/, getUserWords()];
                case 7:
                    familiar_4 = _e.sent();
                    preResult = shuffle(arr.flat()).slice(0, 20);
                    preResult.forEach(function (element) {
                        var elem = familiar_4.find(function (q) { return q.wordId === element.id; });
                        if (elem) {
                            element.properties = elem;
                            element.isNew = false;
                        }
                        else {
                            element.isNew = true;
                        }
                    });
                    _b = shuffle;
                    return [4 /*yield*/, createFalseWords(preResult)];
                case 8:
                    falseWords_2 = _b.apply(void 0, [_e.sent()]);
                    preResult.forEach(function (element, index) {
                        element.variant = [element.wordTranslate];
                        for (var i = 0; i < 4; i += 1) {
                            element.variant.push(falseWords_2[index * 4 + i].wordTranslate);
                        }
                        element.variant = shuffle(element.variant);
                    });
                    return [3 /*break*/, 13];
                case 9:
                    if (!fromPage) return [3 /*break*/, 11];
                    arr.forEach(function (element) { return shuffle(element); });
                    preResult = arr.flat().slice(0, 20);
                    _c = shuffle;
                    return [4 /*yield*/, createFalseWords(preResult)];
                case 10:
                    falseWords_3 = _c.apply(void 0, [_e.sent()]);
                    preResult.forEach(function (element, index) {
                        element.variant = [element.wordTranslate];
                        for (var i = 0; i < 4; i += 1) {
                            element.variant.push(falseWords_3[index * 4 + i].wordTranslate);
                        }
                        element.variant = shuffle(element.variant);
                    });
                    return [3 /*break*/, 13];
                case 11:
                    preResult = shuffle(arr.flat()).slice(0, 20);
                    _d = shuffle;
                    return [4 /*yield*/, createFalseWords(preResult)];
                case 12:
                    falseWords_4 = _d.apply(void 0, [_e.sent()]);
                    preResult.forEach(function (element, index) {
                        element.variant = [element.wordTranslate];
                        for (var i = 0; i < 4; i += 1) {
                            element.variant.push(falseWords_4[index * 4 + i].wordTranslate);
                        }
                        element.variant = shuffle(element.variant);
                    });
                    _e.label = 13;
                case 13: return [2 /*return*/, preResult];
            }
        });
    });
}
function createFalseWords(arr) {
    return __awaiter(this, void 0, void 0, function () {
        var numbers, q, i, url, resp;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    numbers = Array(10).fill(0);
                    numbers = numbers.map(function () { return [getRandomInt(0, 29), getRandomInt(0, 5)]; });
                    q = [];
                    for (i = 0; i < numbers.length; i += 1) {
                        url = "https://qwerzxvxzvzxvxzv.herokuapp.com/words?page=".concat(numbers[i][0], "&group=").concat(numbers[i][1]);
                        q.push(fetch(url));
                    }
                    return [4 /*yield*/, Promise.all(q.map(function (elem) { return __awaiter(_this, void 0, void 0, function () {
                            var resp1, body;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, elem];
                                    case 1:
                                        resp1 = _a.sent();
                                        return [4 /*yield*/, resp1.json()];
                                    case 2:
                                        body = _a.sent();
                                        return [2 /*return*/, body];
                                }
                            });
                        }); }))];
                case 1:
                    resp = _a.sent();
                    return [2 /*return*/, resp
                            .flat()
                            .filter(function (elem) { return !arr.some(function (element) { return element.id === elem.id; }); })];
            }
        });
    });
}
export function handleWord(element, correct, game) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var method, isUser;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    element.isNew = false;
                    method = 'PUT';
                    if (!element.properties) {
                        method = 'POST';
                        element.properties = {
                            difficulty: 'easy',
                            optional: {
                                isKnown: false,
                                streak: correct ? 1 : 0,
                            },
                        };
                    }
                    else if (!correct) {
                        delete element.properties.wordId;
                        delete element.properties.id;
                        if (element.properties.optional) {
                            element.properties.optional.isKnown = false;
                            element.properties.optional.streak = 0;
                        }
                    }
                    else {
                        delete element.properties.wordId;
                        delete element.properties.id;
                        if (element.properties.difficulty === 'easy') {
                            if (element.properties.optional) {
                                if (((_a = element.properties.optional) === null || _a === void 0 ? void 0 : _a.streak) === undefined) {
                                    element.properties.optional.streak = element.properties.optional
                                        .isKnown
                                        ? 3
                                        : 0;
                                }
                                element.properties.optional.streak =
                                    ((_b = element.properties.optional) === null || _b === void 0 ? void 0 : _b.streak) + 1;
                                element.properties.optional.isKnown =
                                    ((_c = element.properties.optional) === null || _c === void 0 ? void 0 : _c.streak) > 2;
                            }
                        }
                        else if (element.properties.optional) {
                            if (((_d = element.properties.optional) === null || _d === void 0 ? void 0 : _d.streak) === undefined)
                                element.properties.optional.streak = 0;
                            element.properties.optional.streak =
                                element.properties.optional.streak + 1;
                            if (element.properties.optional.streak > 4) {
                                element.properties.difficulty = 'easy';
                                element.properties.optional.isKnown = true;
                            }
                        }
                    }
                    if (element.properties.optional) {
                        if (game === 'audiochallenge')
                            element.properties.optional.lastaudio = correct;
                        else
                            element.properties.optional.lastsprint = correct;
                    }
                    return [4 /*yield*/, isUserHere()];
                case 1:
                    isUser = _e.sent();
                    if (isUser) {
                        try {
                            setUserWords(element.id || '', element.properties, method);
                        }
                        catch (error) {
                            console.log(error);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function isUserHere() {
    return __awaiter(this, void 0, void 0, function () {
        var userinfo, user, baseurl, resp, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    userinfo = localStorage.getItem('userInfo');
                    if (!userinfo)
                        return [2 /*return*/, false];
                    user = JSON.parse(userinfo);
                    baseurl = "https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(user.userId);
                    return [4 /*yield*/, fetch(baseurl, {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(user.token),
                                Accept: 'application/json',
                            },
                        })];
                case 1:
                    resp = _a.sent();
                    if (!resp.ok)
                        throw new Error('qwertr');
                    else
                        return [2 /*return*/, true];
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.log(err_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function setUserStats(stats) {
    return __awaiter(this, void 0, void 0, function () {
        var userinfo, user, baseurl;
        return __generator(this, function (_a) {
            userinfo = localStorage.getItem('userInfo');
            if (userinfo === null)
                return [2 /*return*/];
            else {
                user = JSON.parse(userinfo);
                baseurl = "https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(user.userId, "/statistics");
                fetch(baseurl, {
                    method: 'PUT',
                    headers: {
                        Authorization: "Bearer ".concat(user.token),
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(stats),
                    keepalive: true,
                });
            }
            return [2 /*return*/];
        });
    });
}
export function handleStats(stats, gathered, game) {
    var _a, _b, _c, _d, _e;
    delete stats.id;
    var timestamp = new Date((_a = stats === null || stats === void 0 ? void 0 : stats.optional) === null || _a === void 0 ? void 0 : _a.date);
    var now = new Date();
    var long = JSON.parse(stats.optional.long);
    if (game === 'sprint') {
        if (timestamp.getFullYear() === now.getFullYear() &&
            timestamp.getMonth() === now.getMonth() &&
            timestamp.getDate() === now.getDate()) {
            stats.optional.sprint.percentage =
                (((_c = (_b = stats.optional) === null || _b === void 0 ? void 0 : _b.sprint) === null || _c === void 0 ? void 0 : _c.percentage) * stats.optional.sprint.answers +
                    gathered.correctAnswers) /
                    (stats.optional.sprint.answers + gathered.answers);
            stats.optional.sprint.answers += gathered.answers;
            stats.optional.sprint.newWords += gathered.new;
            stats.optional.sprint.biggestStreak =
                stats.optional.sprint.biggestStreak > gathered.bigStreak
                    ? stats.optional.sprint.biggestStreak
                    : gathered.bigStreak;
            stats.learnedWords += gathered.learned;
            long[0] = {
                new: stats.optional.sprint.newWords +
                    stats.optional.audiochallenge.newWords,
                date: stats.optional.date,
                learned: stats.learnedWords,
            };
            stats.optional.long = JSON.stringify(long);
        }
        else {
            long.unshift({
                new: gathered.new,
                date: now,
                learned: gathered.learned,
            });
            stats.optional.long = JSON.stringify(long);
            stats.optional.audiochallenge = defaultstats.optional.audiochallenge;
            stats.optional.sprint.percentage =
                gathered.correctAnswers / gathered.answers;
            stats.optional.sprint.answers = gathered.answers;
            stats.optional.sprint.biggestStreak = gathered.bigStreak;
            stats.optional.sprint.newWords = gathered.new;
            stats.learnedWords = gathered.learned;
            stats.optional.date = new Date();
        }
    }
    else {
        if (timestamp.getFullYear() === now.getFullYear() &&
            timestamp.getMonth() === now.getMonth() &&
            timestamp.getDate() === now.getDate()) {
            stats.optional.audiochallenge.percentage =
                (((_e = (_d = stats.optional) === null || _d === void 0 ? void 0 : _d.audiochallenge) === null || _e === void 0 ? void 0 : _e.percentage) *
                    stats.optional.audiochallenge.answers +
                    gathered.correctAnswers) /
                    (stats.optional.audiochallenge.answers + gathered.answers);
            stats.optional.audiochallenge.answers += gathered.answers;
            stats.optional.audiochallenge.newWords += gathered.new;
            stats.optional.audiochallenge.biggestStreak =
                stats.optional.audiochallenge.biggestStreak > gathered.bigStreak
                    ? stats.optional.audiochallenge.biggestStreak
                    : gathered.bigStreak;
            stats.learnedWords += gathered.learned;
            long[0] = {
                new: stats.optional.sprint.newWords +
                    stats.optional.audiochallenge.newWords,
                date: stats.optional.date,
                learned: stats.learnedWords,
            };
            stats.optional.long = JSON.stringify(long);
        }
        else {
            long.unshift({
                new: gathered.new,
                date: now,
                learned: gathered.learned,
            });
            stats.optional.long = JSON.stringify(long);
            stats.optional.sprint = defaultstats.optional.sprint;
            stats.optional.audiochallenge.percentage =
                gathered.correctAnswers / gathered.answers;
            stats.optional.audiochallenge.answers = gathered.answers;
            stats.optional.audiochallenge.biggestStreak = gathered.bigStreak;
            stats.optional.audiochallenge.newWords = gathered.new;
            stats.learnedWords = gathered.learned;
            stats.optional.date = new Date();
        }
    }
    setUserStats(stats);
}
export function learned(before, after) {
    if (!before && after)
        return 1;
    else
        return 0;
}
export function setUserWordsTextBook(wordId, word, method) {
    if (method === void 0) { method = 'POST'; }
    return __awaiter(this, void 0, void 0, function () {
        var NonStringedUser, user, token, url, rawResp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    NonStringedUser = localStorage.getItem('userInfo');
                    user = JSON.parse(NonStringedUser);
                    token = user.token;
                    url = "https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(user.userId, "/words/").concat(wordId);
                    return [4 /*yield*/, fetch(url, {
                            method: method,
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(word),
                        })];
                case 1:
                    rawResp = _a.sent();
                    return [4 /*yield*/, rawResp.json()];
                case 2:
                    resp = _a.sent();
                    return [2 /*return*/, resp];
            }
        });
    });
}
export function test1(page, group) {
    if (page === void 0) { page = 0; }
    if (group === void 0) { group = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var NonStringedUser, user, token, id, filter, baseurl, rawResp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    NonStringedUser = localStorage.getItem('userInfo');
                    user = JSON.parse(NonStringedUser);
                    token = user.token;
                    id = user.userId;
                    filter = {
                        $or: [
                            { 'userWord.difficulty': 'hard', 'userWord.optional.isKnown': 'true' },
                        ],
                    };
                    baseurl = "https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(id, "/aggregatedWords?group=").concat(group, "\n&wordsPerPage=").concat((page + 1) * 20, "&filter=").concat(JSON.stringify(filter));
                    return [4 /*yield*/, fetch(baseurl, {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                Accept: 'application/json',
                            },
                        })];
                case 1:
                    rawResp = _a.sent();
                    return [4 /*yield*/, rawResp.json()];
                case 2:
                    resp = _a.sent();
                    return [2 /*return*/, resp[0].paginatedResults];
            }
        });
    });
}
export function test3() {
    return __awaiter(this, void 0, void 0, function () {
        var user, info, id, raw, resp, str;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    user = localStorage.getItem('userInfo');
                    info = JSON.parse(user);
                    id = info.userId;
                    return [4 /*yield*/, fetch("https://qwerzxvxzvzxvxzv.herokuapp.com/users/".concat(id, "/tokens"), {
                            headers: {
                                Authorization: "Bearer ".concat(info.refreshToken),
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    raw = _a.sent();
                    return [4 /*yield*/, raw.json()];
                case 2:
                    resp = _a.sent();
                    info.token = resp.token;
                    info.refreshToken = resp.refreshToken;
                    str = JSON.stringify(info);
                    localStorage.setItem('userInfo', str);
                    return [2 /*return*/];
            }
        });
    });
}
